import { render } from "./article-set.vue?vue&type=template&id=1848907e&scoped=true&ts=true"
import script from "./article-set.vue?vue&type=script&lang=ts"
export * from "./article-set.vue?vue&type=script&lang=ts"

import "./article-set.vue?vue&type=style&index=0&id=1848907e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1848907e"]])

export default __exports__